import { User } from 'oidc-client-ts';

export function portalTokenKey(): string {
  return `oidc.user:${process.env.REACT_APP_TRIMBLEID_AUTHORITY}:${process.env.REACT_APP_TRIMBLEID_CLIENT_ID}`;
}

export function portalToken(): string | null {
  const oidcStorage = localStorage.getItem(portalTokenKey());

  if (!oidcStorage) {
    return null;
  }

  const lsAuth = User.fromStorageString(oidcStorage);

  return lsAuth.access_token;
}

export default portalToken;
